import { useAuth0 } from '@auth0/auth0-react';
import MainWindow from '../../app_layout/main_window/MainWindow';
import ChatWindow from '../../app_layout/chat_window/ChatWindow';
import SideBar from '../../app_layout/sidebar/SideBar';
import APP_WINDOW_CONFIG from '../../app_layout/layout_config';

// imports relevant for HTTP calls
import DisplayException from '../../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import {SERVER_URL, WEBSOCKET_URL} from '../../config_server_url';

// import user session information
import UserSessionContext from '../../user_session/context_user_session';
import { SetSessionInfo_OnDeleteCurrentProject, SetSessionInfo_OnDeleteCurrentCampaign } from '../../user_session/session_info_utils';

import CampaignTree from './CampaignTree';
import InfoPopup from '../../popup_windows/InfoPopup';

import { useNavigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';



function PageCampaignTreeView() {

    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    // This Component requires to fetches data on first load -> setIsloading(true);
    // This Component does not fetch data on first load -> setIsloading(false);
    const [isLoading, setIsLoading] = useState(false);

    // ------------------ Load User Session Information ---------------------------------
    const usr_session_ctx = useContext(UserSessionContext);
    const { user } = useAuth0();
    const [broadcastProject, setBroadcastProject] = useState([]); //get session notifications via web sockets
    const [broadcastCampaign, setBroadcastCampaign] = useState([]); //get session notifications via web sockets
    const [onOkBroadcastCampaign, setOnOkBroadcastCampaign] = useState(null);

    // ------------------ Add User Session Websockets For Notification Events Across All Tenant (Workspace) Members -----------------------------

    useEffect(() => {
        // Create WebSocket connection`${SERVER_URL}/all_projects/load/`
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_project/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        // Connection opened
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
          };
        // Listen for messages
        ws.onmessage = (event) => {
        //   console.log('Message received:', event.data);
          let parser = event.data.split('__');
          let sender = parser[0]
          let type = parser[1].split('.')[1]
          let project_uuid = parser[2]
          if (type === 'ProjectDelete'){
            if(project_uuid === usr_session_ctx.session_info.uuid_current_project) {
                let new_broadcast = (<>{sender} has deleted <strong>your current project uuid:{project_uuid}</strong></>);
                usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentProject(usr_session_ctx);
                handleUpdateUserSession()
                setBroadcastProject(prevBroadcast => [...prevBroadcast, new_broadcast]);
            }
          }
        };
        // Connection closed
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
          ws.close();
        };
      }, []); // Effect runs when tenant_id or user_id changes

    
      useEffect(() => {
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_campaign/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
        };
        // Listen for messages
        ws.onmessage = (event) => {
            // console.log('Message received:', event.data);
            let parser = event.data.split('__');
            let sender = parser[0]
            let type = parser[1].split('.')[1]
            let project_uuid = parser[2]
            let campaign_uuid = parser[3]
            if (project_uuid === usr_session_ctx.session_info.uuid_current_project && campaign_uuid === usr_session_ctx.session_info.uuid_current_opt_campaign){
                if (type === 'CampaignDelete'){
                        let new_broadcast = (<>{sender} has deleted <strong>your current campaign uuid:{campaign_uuid}</strong></>);
                        usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
                        handleUpdateUserSession()
                        setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                        setOnOkBroadcastCampaign(() => () => {
                            setBroadcastCampaign([]); // Clear broadcast state
                            setCurrentCampaignExists(false);  // 
                          });
                }
                if (type === 'UpdateCampaignTitle'){
                    let new_broadcast = (<>{sender} has updated the campaign title.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadTree()
                      });
                }
                if (type === 'CampaignCycleCreate'){
                    let new_broadcast = (<>{sender} has created a new cycle.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                            setBroadcastCampaign([]); // Clear broadcast state
                            loadTree()  // 
                        });
                }
                if (type === 'CampaignCycleDelete'){
                    let new_broadcast = (<>{sender} has deleted a cycle for campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                            setBroadcastCampaign([]); // Clear broadcast state
                            loadTree()  // 
                        });
                }
                if (type === 'CampaignDataUpload'){
                    let new_broadcast = (<>{sender} has uploaded new data.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                            setBroadcastCampaign([]); // Clear broadcast state
                            loadTree()  // 
                        });
                }
                if (type === 'CampaignDataRemoved'){
                    let new_broadcast = (<>{sender} has removed data.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                            setBroadcastCampaign([]); // Clear broadcast state
                            loadTree()  // 
                        });
                }
                if (type === 'UpdateAsNewCampaignExperimentalWorkflow'){
                    let new_broadcast = (<>{sender} has updated active Experimental Workflow as new object.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadTree()
                      });
                }
                if (type === 'UpdateAsNewCampaignDesignSpace'){
                    let new_broadcast = (<>{sender} has updated active Design Space as new object.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadTree()
                      });
                }
                if (type === 'UpdateAsNewCampaignObjective'){
                    let new_broadcast = (<>{sender} has updated active Objective as new object.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        loadTree()
                      });
                }
            }
        };
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
        ws.close();
        };
    }, []); // Effect runs when tenant_id or user_id changes



      function handleUpdateUserSession() {
        setIsLoading(true);
        let session_update = {key: 'session_info', value: usr_session_ctx.session_info}
        fetch(`${SERVER_URL}/user_session/update_field/`, {method: 'PUT',
                                                           headers:{'Content-Type':'application/json',
                                                                   'auth0_user': user.sub,
                                                                   'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                                                           body:JSON.stringify(session_update)
        })
        .then((res) => {
        if(!res.ok) {
            throw new Error(`HTTP error ${res.status}`);
        }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false);
        })
            .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
   }



    // ------------------ General Window Layout -----------------------------
        
    const [canvasSize, setCanvasSize] = useState({width: 0, height: 0});
    const [layout, setLayout] = useState({sidebar:0, main: 0, chat: 0});
    const [toggleSideBar, setToggleSideBar] = useState(false);

    useEffect(() => {
        function handleResize() {
            let window_height = window.innerHeight;
            let window_width = window.innerWidth;
            let canvas_height = window_height - APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = (window_width - sidebar)*APP_WINDOW_CONFIG.CHAT_WIDTH_RELATIVE;
            chat = Math.max (chat, APP_WINDOW_CONFIG.MIN_CHAT_WIDTH_PX);
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setCanvasSize({width: window_width, height: canvas_height});
            // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
            if(toggleSideBar){
                sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
                main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            }
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        // Set initial height
        handleResize();
        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);
        // Remove event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [toggleSideBar]); // Empty dependency array ensures the effect only runs once


    function handleToggle() {
        // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
        if(!toggleSideBar){
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        else
        {
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        setToggleSideBar(!toggleSideBar);
    }


// ------------------ Side Bar Content -----------------------------

    let sidebar = (<>
        <SideBar width={layout.sidebar} 
                toggle={toggleSideBar} 
                handle_toggle={handleToggle} 
                active_link='campaign_tree_view' >
        </SideBar>
    </>)


// ------------------ Main Window Content ----------------------------

    const [campaignTree, setCampaignTree] = useState(null)
    const [campaignInfo, setCampaignInfo] = useState(null)
    const [currentCampaignExists, setCurrentCampaignExists] = useState(false)

    const navigate = useNavigate();


    function loadTree(){
        const uuid_opt_campaign = usr_session_ctx.session_info.uuid_current_opt_campaign;
        if(uuid_opt_campaign === '') {setCurrentCampaignExists(false)}
        else{
            setCurrentCampaignExists(true)
            setIsLoading(true); // Set loading state to true when fetch begins    // server retunrs -> cols about what info is shown. 
            fetch(`${SERVER_URL}/current_opt_campaign/load_campaign_tree_view/`, {method: 'POST',
                                                    headers:{'Content-Type':'application/json',
                                                                'uuid_tenant': usr_session_ctx.uuid_tenant },
                                                    body:JSON.stringify(uuid_opt_campaign)
                                                    })
            .then((res) => {
                if(!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((loaded_tree) => {
                if(loaded_tree.msg === ''){
                    setIsLoading(false); 
                    setCampaignTree(loaded_tree.data.tree)
                    setCampaignInfo(loaded_tree.data.campaign_info)
                }
                else{
                    let new_broadcast = (<>Your current campaign does not exist anymore.</>);
                    usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
                    handleUpdateUserSession()
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    setOnOkBroadcastCampaign(() => () => {
                        setBroadcastCampaign([]); // Clear broadcast state
                        setCurrentCampaignExists(false);
                        loadTree();    
                      });
                    setIsLoading(false); 
                }
            })
            .catch((err) => {
                setException(true);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            });
        }
    }

    // Fetch All Projects
    useEffect(() => {
        loadTree();
    }, []);



    let mainWindow = (<></>);
    // Exection and Error Messeges Get Priority and Are Evaluated Before Anything els
    if(Exception){
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <DisplayException>
                        {ExceptionMessage}
                    </DisplayException>  
                </MainWindow>
            </>);
    }

    if (!isLoading && !Exception && currentCampaignExists && broadcastProject.length === 0 && broadcastCampaign.length === 0) { 
        mainWindow = (<>
            <MainWindow width={layout.main} >
                <h3 style = {{marginLeft:'0px', marginBottom:'0px', marginTop:'20px', position: 'relative', left:'3%'}} >Campaign Tree</h3>
                <p style={{position: 'relative', left:'3%', marginTop:'3px', marginBottom:'0px', fontSize:'14px'}}>Campaign Title: {campaignInfo.title}</p>
                <p style={{position: 'relative', left:'3%', marginTop:'3px', marginBottom:'5px', fontSize:'14px'}}>Campaign UUID: {campaignInfo.uuid}</p>
                {/* <div style={{position: 'relative', left: '50%',  transform: 'translate(-50%,0% )', width:'94%', paddingTop:'10px', height:'80%', overflow:'auto', border:'1px solid var(--aixelo-red)'}}> */}
                    <CampaignTree 
                        height='100%'
                        tree={campaignTree}/>
                {/* </div> */}
            </MainWindow>
        </>);
    }


    if (!isLoading && !Exception && !currentCampaignExists && broadcastProject.length === 0 && broadcastCampaign.length === 0) { 
        mainWindow = (<>
            <MainWindow width={layout.main} >
                <div style={{fontSize:'18px', position:'relative', textAlign:'center', height:'fit-content', marginTop:'50px', width:'100%'}} >
                There is no optimization campaign in focus. <br />Create or load an optimization campaign.
                </div> 
                <div style={{position: 'relative', display: 'flex', gap:'20px', justifyContent:'center', marginTop:'25px', left:'3%', width:'94%'}}>
                <button className={'actionButton'} style={{width:'150px'}} onClick={()=>{navigate('/campaign_builder')}} >Create Campaign</button>
                <button className={'actionButton'} style={{width:'150px', marginRight:'0px'}} onClick={()=>{navigate('/optimization_campaigns')}}>Load Campaign</button>
                </div>                
            </MainWindow>
        </>);
    }

    if (!isLoading && !Exception && broadcastCampaign.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={onOkBroadcastCampaign} >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastCampaign.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }

    if (!isLoading && !Exception && broadcastProject.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastProject(prevBroadcast => []); navigate('/')} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastProject.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }


    if (isLoading && !Exception) {   
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </MainWindow>
            </>);
       }


// ------------------ Return All Components ----------------------------

    // Show Sidebar, MainWindow and ChatWindow
    return(
        <>
        <div style={{position:'relative', display:'grid', gridTemplateColumns: 'auto auto auto', overflow: 'hidden', left:`${APP_WINDOW_CONFIG.OFFSET_WINDOW_LEFT_PX}px`, top:`${APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX}px`, height:canvasSize.height, width:'100%'}}>
            {sidebar}
            {mainWindow}
            <ChatWindow width={layout.chat}/>
        </div>    
        </>
    );

}


export default PageCampaignTreeView;
